<template>
  <q-page padding>
    <div class="card q-pa-md text-brand-5 text-weight-bold">
      <div class="row col-12 topo q-mb-sm">
        <div style="width: 18%" class="column justify-around top">
          <q-img
            v-if="dadosDescricao?.url_logo"
            :src="dadosDescricao?.url_logo"
          />
          <q-img v-else src="../../../assets/MULTPEX_VETOR.png" />
        </div>
        <div
          class="master-title"
          v-if="dadosDescricao"
          v-html="dadosDescricao.titulo"
        ></div>
      </div>
      <div v-if="dadosDescricao" v-html="dadosDescricao.cabecalho"></div>
      <div class="col-12 q-mt-md">
        <q-table
          :columns="columnsUsuario"
          :rows="usuarioDados"
          hide-bottom
          dense
          class="my-sticky-header-table"
          table-header-class="bg-white text-black text-weight-bold"
          flat
        >
          <template v-slot:body-cell-dataAdmissao="props">
            <q-td :props="props">
              <span v-if="props.row.admission_date">{{
                props.row.admission_date
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
            </q-td>
          </template>
          <template v-slot:body-cell-dataDemissao="props">
            <q-td :props="props">
              <span v-if="props.row.demission_date">{{
                props.row.demission_date
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
            </q-td>
          </template>
        </q-table>

        <q-table
          :columns="columnsTabela"
          :rows="dadosFichaEpi"
          :rows-per-page-options="[0]"
          style="margin-bottom: 80px"
          dense
          table-header-class="bg-white text-black text-weight-bold"
          flat
          hide-bottom
          class="my-sticky-header-table q-mt-md"
        >
          <template v-slot:body-cell-EntregueEm="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span v-if="props.row.RetiradoPorData">{{
                props.row.RetiradoPorData.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
            </q-td>
          </template>

          <template v-slot:body-cell-autenticacaoCriacao="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span
                v-if="
                  props.row.AprovacaoAutenticacaoTipo != 'biometria' &&
                  props.row.AprovacaoAutenticacaoTipo != 'assinatura' &&
                  props.row.AprovacaoAutenticacaoTipo != 'facial'
                "
                >Assinado eletronicamente</span
              >
              <span v-else>
                <q-img
                  :src="props.row.AprovacaoAutenticacao"
                  style="max-width: 300px; height: 70px"
                  fit="contain"
                >
                </q-img
              ></span>
            </q-td>
          </template>
          <template v-slot:body-cell-autenticacaoFinalizacao="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span
                v-if="
                  props.row.FinalizacaoAutenticacaoTipo != 'biometria' &&
                  props.row.FinalizacaoAutenticacaoTipo != 'assinatura' &&
                  props.row.FinalizacaoAutenticacaoTipo != 'facial'
                "
                >Assinado eletronicamente</span
              >
              <span v-else>
                <q-img
                  :src="props.row.FinalizacaoAutenticacao"
                  style="max-width: 300px; height: 70px"
                  fit="contain"
                >
                </q-img
              ></span>
            </q-td>
          </template>
        </q-table>

        <div class="assinatura">
          <span
            >Eu,
            <span v-if="usuarioDados">{{ usuarioDados[0].name }}</span>
            reconheço que recebi os materiais acima descritos nas datas acima
            indicadas</span
          >
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const quasar = useQuasar();
    const pdtDawnload = ref(0);
    const columnsUsuario = ref([
      {
        name: "name",
        label: "Nome",
        align: "left",
        field: "name",
      },
      {
        name: "sap",
        label: "ID Usuário",
        align: "left",
        field: "sap",
      },
      {
        name: "dataAdmissao",
        label: "Data admissão",
        align: "left",
        field: "dataAdmissao",
      },
      {
        name: "cargo",
        label: "Cargo",
        align: "left",
        field: "cargo",
      },
      {
        name: "dataDemissao",
        label: "Data demissão",
        align: "left",
        field: "dataDemissao",
      },
      {
        name: "function",
        label: "Função/GHE",
        align: "left",
        field: "function",
      },
    ]);
    const columnsTabela = ref([
      {
        name: "EntregaUnidadeNome",
        label: "Planta",
        align: "left",
        field: "EntregaUnidadeNome",
        style: "white-space: normal",
      },
      {
        name: "SolicitanteFuncao",
        label: "Função/GHE",
        align: "left",
        field: "SolicitanteFuncao",
        style: "white-space: normal",
      },
      {
        name: "CentroCustoCodigo",
        label: "Centro de Custo",
        align: "left",
        field: (row) => row.CentroCustoCodigo + " - " + row.CentroCustoNome,
        style: "white-space: normal",
      },

      {
        name: "CentroCustoNome",
        label: "Área",
        align: "left",
        field: "CentroCustoNome",
        style: "white-space: normal",
      },
      {
        name: "CentroCustoResponsavel",
        label: "Resp. CC",
        align: "left",
        field: "CentroCustoResponsavel",
        style: "white-space: normal",
      },
      {
        name: "RequisicaoNumero",
        label: "Num Voucher",
        align: "left",
        field: "RequisicaoNumero",
        style: "white-space: normal",
      },

      {
        name: "EntregueEm",
        label: "Entregue em",
        align: "left",
        field: "RetiradoPorData",
        style: "white-space: normal",
      },
      {
        name: "ItemCodigo",
        label: "Cód. Produto",
        align: "left",
        field: "ItemCodigo",
        style: "white-space: normal",
      },
      {
        name: "ItemNomeContrato",
        label: "Descrição",
        align: "left",
        field: "ItemNomeContrato",
        style: "white-space: normal",
      },
      {
        name: "ItemCaCodigo",
        label: "CA",
        align: "left",
        field: "ItemCaCodigo",
        style: "white-space: normal",
      },
      {
        name: "ItemQuantidade",
        label: "Quantidade",
        align: "left",
        field: "ItemQuantidade",
        style: "white-space: normal",
      },
      {
        name: "RequisicaoNumero",
        label: "Requisição",
        align: "left",
        field: "RequisicaoNumero",
        style: "white-space: normal",
      },
      {
        name: "autenticacaoCriacao",
        style: "height: 70px; white-space: normal",
        label: "Autenticação Criação",
        align: "rigth",
      },
      {
        name: "autenticacaoFinalizacao",

        style: "height: 70px; white-space: normal",

        label: "Autenticação Finalização.",
        align: "rigth",
      },
    ]);
    const dadosDescricao = ref("");
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    const params = ref({
      unidade: route.params.unidadeId,
      dataInicial: route.params.dataInicial,
      dataFinal: route.params.dataFinal,
      solicitanteId: route.params.solicitanteId,
      solicitanteSap: route.params.solicitanteSap,
      solicitanteName: route.params.solicitanteName,
    });
    const fichaEpiTextos = ref({
      titulo: "",
      dizeres: "",
    });

    const columnsAtivas = ref([]);
    const dadosFichaEpi = ref([]);
    const usuarioDados = ref();

    const listarDadosFichaEpi = async () => {
      quasar.loading.show();

      store.dispatch("pdt/hiddenHeader", false);
      const response = await store.dispatch("seguranca/listarDadosFichaEpi", {
        dataFinal: params.value.dataFinal,
        dataInicial: params.value.dataInicial,
        epi: 1,
        per_page: 1000,
        solicitanteId: params.value.solicitanteId,
        solicitanteSap: params.value.solicitanteSap,
      });

      dadosFichaEpi.value = await response.data.return.data;
      quasar.loading.hide();
      setTimeout(() => {
        window.print();
      }, 3000);
    };

    const listarDescricao = async () => {
      const response = await store.dispatch("seguranca/getDescricao", {
        vendor_id: params.value.unidade,
      });

      dadosDescricao.value = response.data.response;
    };

    const listarDadosUsuario = async () => {
      const response = await store.dispatch("seguranca/listarUsuarios", {
        per_page: 1,
        vendor_id: params.value.unidade,
        search: params.value.solicitanteName,
      });
      usuarioDados.value = [response.data.results.data[0]];
    };

    const listarColunasUsuario = async () => {
      const response = await store.dispatch("seguranca/listarColunasUsuario", {
        per_page: 1,
        vendor_id: params.value.unidade,
        search: params.value.solicitanteSap,
      });

      response.data.response.forEach((data) => {
        let index = columnsUsuario.value.findIndex((e) => {
          return e.label == data.info_usuario;
        });
        if (data.ativo == false) {
          columnsUsuario.value.splice(index, 1);
        }
      });
    };

    const listarColunasTabela = async () => {
      const response = await store.dispatch("seguranca/listarColunasTabela", {
        per_page: 1,
        vendor_id: params.value.unidade,
        search: params.value.solicitanteSap,
      });

      response.data.response.forEach((data) => {
        let index = columnsTabela.value.findIndex((e) => {
          return e.label == data.info_entrega;
        });
        if (data.ativo == false) {
          columnsTabela.value.splice(index, 1);
        }
      });
    };

    onMounted(listarDadosFichaEpi);
    onMounted(listarDadosUsuario);
    onMounted(listarColunasUsuario);
    onMounted(listarColunasTabela);
    onMounted(listarDescricao);

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    return {
      columnsUsuario,
      columnsTabela,
      listarDadosFichaEpi,
      params,
      fichaEpiTextos,
      columnsAtivas,
      dadosFichaEpi,
      listarDadosUsuario,
      usuarioDados,
      dadosDescricao,
      pdtDawnload,
    };
  },
};
</script>

<style lang="sass">
@page
  size: A4 landscape


.topo
  align-items: center

.topo .master-title
  margin: 0 auto
  color: #000
  font-weight: bold

.assinatura
  border-top: 2px solid black
  width: 690px
  color: black
  margin:0 auto

@media print
  .q-table__middle
    overflow: unset !important

  .my-sticky-header-table
    /* height or max-height is important */

    .q-table__top,
    .q-table__bottom,
    thead tr:first-child th
      /* bg color is important for th; just specify one */

    thead tr th
      font-size: 11px
    tbody tr td
      font-size: 10px
      white-space: pre-wrap
    thead tr:first-child th
      top: 0

    /* this is when the loading indicator appears */
    &.q-table--loading thead tr:last-child th
      /* height of all previous header rows */
      top: 48px
</style>
